import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M39.6 19 28.1 30.4c-3.2 3.1-8.3 3.1-11.5 0L5.1 19h10.8l1.3 1.2 3.7 3.6c.4.4 1 .7 1.6.7s1.2-.2 1.6-.7l3.7-3.6 1.3-1.2h10.8Z",
		className: "icon-fill-secondary"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M42.7 17.7H32.4V7.5h6.5V0H6.1v7.4h6.2v10.2H0v2.5h4.5l11.2 11c1.8 1.8 4.2 2.7 6.6 2.7s4.8-.9 6.6-2.7l11.2-11H45v-2.5h-2.3ZM8.6 5V2.6h27.8V5H8.6Zm21.3 2.6v10.3l-1.1 1-1.3 1.2-3.7 3.6c-.4.4-1 .7-1.6.7s-1.2-.2-1.6-.7l-3.7-3.6-1.3-1.2-1.1-1V7.6h15.2Zm-2.7 21.8c-2.7 2.7-7.1 2.6-9.8 0L8 20.2h5.4l5.5 5.4c.9.9 2.1 1.4 3.4 1.4s2.4-.5 3.4-1.4l5.5-5.4h5.4l-9.4 9.2ZM0 42.5h45V45H0z",
		className: "icon-fill-primary"
	})]
});
export default SvgIcon;
